import React from "react";
import {
  Nav,
  NavLink,
  Bars,
  NavMenu,
  NavBtn,
  NavBtnLink,
} from "./NavBarElements";

const Navbar = () => {
  return (
    <>
      <Nav>

        <NavMenu >
          <NavLink style={{ color: "black", fontFamily: 'Lucida Console', fontSize: 16, }} to="/Home" >
            A Quick Recap (2023)
          </NavLink>
          <NavLink style={{ color: "black", fontFamily: 'Lucida Console', fontSize: 20, }} to="/PictureFinder" activeStyle>
            Picture Finder
          </NavLink>
          <NavLink style={{ color: "black", fontFamily: 'Lucida Console', fontSize: 20, }} to="/LoganReviews" activeStyle>
            Logan Reviews
          </NavLink>
          <NavLink style={{ color: "black", fontFamily: 'Lucida Console', fontSize: 20, }} to="/HowLong" activeStyle>
            How long?
          </NavLink>
          <NavLink style={{ color: "black", fontFamily: 'Lucida Console', fontSize: 20, }} to="/LoganOnly" activeStyle>
            Logan only!!
          </NavLink>
          <NavLink style={{ color: "black", fontFamily: 'Lucida Console', fontSize: 20, }} to="/Feb12" activeStyle>
            Feb12 (2023)
          </NavLink>
          <NavLink style={{ color: "black", fontFamily: 'Lucida Console', fontSize: 18, }} to="/Feb122026" activeStyle>
            Feb 20th (2026)
          </NavLink>
          <NavLink style={{ color: "black", fontFamily: 'Lucida Console', fontSize: 20, }} to="/Statistics" activeStyle>
            Stats
          </NavLink>
          <NavLink style={{ color: "black", fontFamily: 'Lucida Console', fontSize: 20, }} to="/Video" activeStyle>
            August 2022...
          </NavLink>
        </NavMenu>
      </Nav>
    </>
  );
};

export default Navbar;